import { GridLegacy as Grid, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { FC, useContext, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

import { api, IDriver, IListDriversResponse } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";
import { ICriteria } from "./common/types";
import { useUserParams } from '../../../context/user-params-context';


export const DriverSelector: FC<ICriteria> = () => {
  const { t } = useTranslation();
  const { userParams, setUserParams, clearParams } = useUserParams()

  const listDrivers = api.hooks.chart.listDrivers();
  const session = useContext(SessionContext);
  const [drivers, setDrivers] = useState<IDriver[]>([]);

  const convertDriversListToUuidList = (drivers: IDriver[]): string[] => {
    return (drivers
      .filter((driverObject: IDriver) => typeof driverObject.uuid === 'string')
      .map((driver: IDriver) => driver.uuid) as unknown as string[])
  };

  useEffect(() => {
    listDrivers.send(
      session.current.context,
      {},
      (response: IListDriversResponse | null) => {
        if (response && response?.drivers) {
          const allDrivers: IDriver = {
            uuid: convertDriversListToUuidList(response.drivers).join(),
            firstName: t('general.all'),
            lastName: ''
          }

          const mappedDrivers = response.drivers.map(driver => {
            return {
              uuid: driver.uuid,
              firstName: driver.firstName,
              lastName: driver.lastName
            }
          }).sort((a, b) => {
            const nameA = `${a.firstName} ${a.lastName}`.toLowerCase();
            const nameB = `${b.firstName} ${b.lastName}`.toLowerCase();
            return nameA.localeCompare(nameB);
          });

          setDrivers([allDrivers, ...mappedDrivers]);
          setUserParams({ "@u_driverIds": allDrivers.uuid.split(',') });
        }
      }
    );

    return () => {
      setDrivers([]);
      clearParams(['@u_driverIds']);
    }
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    setUserParams({ "@u_driverIds": value.split(',') });
  };

  return (
    <Grid item sm={4} md={2}>
      <FormControl sx={{ minWidth: 160 }} size="small" fullWidth>
        <InputLabel>{t("input.criteria.labels.selectDriver")}</InputLabel>
        <Select
          id={"driver-criteria"}
          value={String(userParams["@u_driverIds"]?.join())}
          label={t("input.criteria.labels.selectDriver")}
          onChange={handleChange}
        >
          {drivers.map((driver) => (
            <MenuItem key={driver.uuid} value={driver.uuid}>
              {`${driver.firstName} ${driver.lastName}`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid >
  );
};

export default DriverSelector;
